import React, { Component } from "react";
//import "../login/style.scss";
import { Cookies } from "react-cookie";
import { Route, Redirect, Link } from "react-router-dom";
import { withRouter } from "react-router";
import { observer } from "mobx-react";
import AppStore from "../../stores/AppStore";
import UserStore from "../../stores/UserStore";
import Inner from "../template/Inner";
import Spinner from "react-spinkit";
import api from "../../lib/api";
import moment from "moment";
import UserHistory from "../stats/UserHistory";
import Select from "react-select";
import UserMostViewed from "../stats/UserMostViewed";
import { Tooltip } from "react-tippy";

@observer
class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userb: null,
      error: false,
      subtype: "all",
      agents: [],
      selectedAgent: null
    };
  }

  componentDidMount() {
    this.loadUser(this.props.match.params.userId);
    if (UserStore.isAdmin()) {
      this.loadAgents();
    }
  }

  changeAgent(userId, agentId) {
    //alert("changin to " + agentId + " for user " + userId);
    api.changeAgent(
      userId,
      agentId,
      response => {
        this.loadUser(this.props.match.params.userId);
      },
      error => {
        alert("Error changing agent");
      }
    );
  }

  loadAgents() {
    api.getAgents(
      null,
      null,
      null,
      response => {
        let options = [];

        if (response.agents.length > 0) {
          options.push({ value: null, label: "No agent" });
        }

        response.agents.map(item => {
          options.push({ value: item.id, label: item.display_name });
        });

        this.setState({ agents: options });
      },
      error => {
        this.setState({ agents: [] });
      }
    );
  }

  loadUser(userId) {
    api.getUsers(
      null,
      null,
      null,
      response => {
        if (!response) {
          this.setState({ error: true });
        } else {
          if (response.length == 0) {
            this.setState({ error: true });
          } else {
            this.setState({ user: response.users });
          }
        }
      },
      error => {
        this.setState({ error: true });
      },
      userId
    );
  }

  showUser() {
    if (this.state.error) {
      return (
        <div className="centerBox">
          <img src="https://bk.homestack.com/assets/img/not-found.svg" />
          <h2>Unable to load data</h2>
          <p>
            <button
              onClick={() => {
                this.setState({ error: false });
                this.loadUser(this.props.match.params.userId);
              }}
            >
              Try again
            </button>
          </p>
        </div>
      );
    }

    if (!this.state.user) {
      return (
        <div
          class="d-flex w-100 justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div class="spinner-border text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    const item = this.state.user;

    return (
      <section class="admin-content">
        <div class="bg-dark">
          <div class="container  m-b-30">
            <div class="row">
              <div class="col-12 text-white p-t-40 p-b-90">
                <h4 class="">
                  {" "}
                  <span class="btn btn-white-translucent">
                    <i class="icon-placeholder fe fe-user " />
                  </span>{" "}
                  {item.display_name}
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div class="container pull-up">
          <div class="row">
            <div class="col-lg-6">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="text-center ">
                    {item.photo ? (
                      <img src={item.photo} class="rounded-circle" width="80" />
                    ) : (
                      <div class="avatar avatar-lg">
                        <span class="avatar-title rounded-circle ">
                          {item.display_name
                            .split(" ")
                            .map((n, i, a) =>
                              i === 0 || i + 1 === a.length ? n[0] : null
                            )
                            .join("")
                            .toUpperCase()}
                        </span>
                      </div>
                    )}
                  </div>

                  <h4 class="text-center m-t-20" style={{ marginBottom: 5 }}>
                    {item.display_name}
                  </h4>
                  {item.type == "agent" && (
                    <h5 class="text-center m-t-20" style={{ marginTop: 0 }}>
                      <span class="badge badge-warning">Agent</span>
                    </h5>
                  )}
                  <div class="text-muted text-center m-b-20">
                    Joined {moment.unix(item.created_epoch).fromNow()}
                  </div>

                  <ul className="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between">
                      <div>Email</div>
                      <span>
                        <a
                          className="text-underline"
                          href={"mailto:" + item.email}
                        >
                          {item.email}
                        </a>
                      </span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <div>Phone</div>
                      <div>
                        <a
                          className="text-underline"
                          href={"tel:" + item.phone}
                        >
                          {item.phone}
                        </a>
                        {item.phone_verified && (
                          <Tooltip title="Phone number verified">
                            <span
                              style={{
                                marginLeft: 5,
                                display: "inline-block",
                                width: 20,
                                alignSelf: "center",
                                height: 20,
                                //lineHeight: 20,
                                verticalAlign: "middle",
                                borderRadius: 10,
                                //display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                              class="bg-success text-center"
                            >
                              <i
                                class="fe fe-check"
                                style={{ fontWeight: "bold", color: "#fff" }}
                              ></i>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <div>Total logins</div>
                      <span>{item.login_count}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <div>Last login</div>
                      <span>
                        {moment.unix(item.last_login_epoch).fromNow()}
                      </span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <div>Completed app setup</div>
                      {item.completed_setup ? (
                        <span
                          style={{
                            marginLeft: 5,
                            display: "inline-block",
                            width: 20,
                            alignSelf: "center",
                            height: 20,
                            //lineHeight: 20,
                            verticalAlign: "middle",
                            borderRadius: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                          class="bg-success text-center"
                        >
                          <i
                            class="fe fe-check"
                            style={{ fontWeight: "bold", color: "#fff" }}
                          ></i>
                        </span>
                      ) : (
                        <span
                          style={{
                            marginLeft: 5,
                            display: "inline-block",
                            width: 20,
                            alignSelf: "center",
                            height: 20,
                            //lineHeight: 20,
                            verticalAlign: "middle",
                            borderRadius: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                          class="bg-danger text-center"
                        >
                          <i
                            class="fe fe-x"
                            style={{ fontWeight: "bold", color: "#fff" }}
                          ></i>
                        </span>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card m-b-30">
                <div class="card-body">
                  {item.agent ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center"
                      }}
                    >
                      <div class="avatar avatar-sm">
                        {item.agent.photo ? (
                          <img
                            src={item.agent.photo}
                            class="avatar-img rounded-circle"
                            alt=""
                          />
                        ) : (
                          <div class="avatar-title rounded-circle">
                            {item.agent.display_name
                              .split(" ")
                              .map((n, i, a) =>
                                i === 0 || i + 1 === a.length ? n[0] : null
                              )
                              .join("")
                              .toUpperCase()}
                          </div>
                        )}
                      </div>
                      <div style={{ marginLeft: 20 }}>
                        <span class="text-muted text-left">Agent</span>
                        <br />
                        <Link
                          to={`/agents/${item.agent.id}`}
                          className="text-underline"
                        >
                          {item.agent.display_name}
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <p class="text-muted">No agent set</p>
                  )}

                  {UserStore.isAdmin() && this.state.agents.length > 0 && (
                    <>
                      <hr />
                      <div class="form-group ">
                        <label class="font-secondary">Change agent</label>
                        <Select
                          value={this.state.selectedAgent}
                          options={this.state.agents}
                          onChange={option => {
                            this.setState({ selectedAgent: option });
                          }}
                        />
                      </div>

                      {this.state.selectedAgent != null && (
                        <div class="form-group text-right">
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              this.changeAgent(
                                item.user_id,
                                this.state.selectedAgent.value
                              );
                            }}
                          >
                            Change
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() => {
                              this.setState({ selectedAgent: null });
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              {AppStore.app_data.toggles.savedSearchesEnabled && 1 == 9 && (
                <div class="card m-b-30">
                  <div class="card-header">
                    <h5 class="m-b-0">Actions</h5>
                  </div>
                  <div class="card-body">
                    <ul className="list-group list-group-flush">
                      <li class="list-group-item d-flex justify-content-between">
                        <span>
                          <a className="text-underline" href="#">
                            Create saved search for user
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="card-body"></div>
                </div>
              )}

              <div class="card m-b-30">
                <div class="card-header">
                  <h5 class="m-b-0">Overview</h5>
                </div>
                <div class="card-body">
                  <ul className="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between">
                      <div>
                        <i class="mdi mdi-circle text-warning fw-600"></i>{" "}
                        Favorites
                      </div>
                      <span>{item.meta.favorites}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <div>
                        <i class="mdi mdi-circle text-info fw-600"></i> Notes
                      </div>
                      <span>{item.meta.notes}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <div>
                        <i class="mdi mdi-circle text-success fw-600"></i> Saved
                        searches
                      </div>
                      <span>{item.meta.saved_searches}</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/*<div class="card m-b-30">
                <div class="card-header">
                  <h5 class="m-b-0">Photo</h5>
                </div>
                <div class="card-body">
                  <p>Photo</p>
                  {JSON.stringify(item)}
                </div>
              </div>
              */}
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <UserMostViewed userId={item.user_id} />{" "}
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <div class="card m-b-30">
                <div class="card-header">
                  <h5 class="card-title m-b-0">Recent activity</h5>

                  <div class="card-controls">
                    <select
                      class="custom-select"
                      value={this.state.subtype}
                      onChange={e => {
                        this.setState({ subtype: e.target.value });
                      }}
                    >
                      <option value="all">All</option>
                      <option value="view">Views</option>
                      <option value="fav">Favorites</option>
                      <option value="note">Notes</option>
                      <option value="share">Shares</option>
                    </select>
                  </div>

                  {/*}  <div class="card-controls">
                    <a href="#" class="js-card-fullscreen icon"></a>
                    <div class="dropdown">
                      <a
                        href="#"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {" "}
                        <i class="icon mdi  mdi-dots-vertical"></i>{" "}
                      </a>

                      <div
                        class="dropdown-menu dropdown-menu-right"
                        x-placement="bottom-end"
                        style={{
                          backgroundColor: "red",
                          zIndex: 9000000,
                          position: "absolute",
                          willCchange: "transform",
                          top: 0,
                          left: 0,
                          transform: "translate3d(18px, 24px, 0px)"
                        }}
                      >
                        <button
                          class="dropdown-item"
                          type="button"
                          onClick={() => {
                            this.setState({ subtype: "all" });
                          }}
                        >
                          All activity
                        </button>
                        <button
                          class="dropdown-item"
                          type="button"
                          onClick={() => {
                            this.setState({ subtype: "view" });
                          }}
                        >
                          Views only
                        </button>
                        <button
                          class="dropdown-item"
                          type="button"
                          onClick={() => {
                            this.setState({ subtype: "fav" });
                          }}
                        >
                          Favorites only
                        </button>
                        <button
                          class="dropdown-item"
                          type="button"
                          onClick={() => {
                            this.setState({ subtype: "note" });
                          }}
                        >
                          Notes only
                        </button>
                        <button
                          class="dropdown-item"
                          type="button"
                          onClick={() => {
                            this.setState({ subtype: "share" });
                          }}
                        >
                          Shares only
                        </button>
                      </div>
                    </div>
                  </div>
               */}
                </div>
                <div class="card-body">
                  <UserHistory
                    userId={item.user_id}
                    subtype={this.state.subtype}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  render() {
    return <Inner>{this.showUser()}</Inner>;
  }
}

export default withRouter(User);
